module.exports = __webpack_public_path__ + "static/media/NF.84e305fe.svg";